import { render, staticRenderFns } from "./FeedModelEntry.vue?vue&type=template&id=08be8ae8&scoped=true&"
import script from "./FeedModelEntry.vue?vue&type=script&lang=ts&"
export * from "./FeedModelEntry.vue?vue&type=script&lang=ts&"
import style0 from "./FeedModelEntry.vue?vue&type=style&index=0&id=08be8ae8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08be8ae8",
  null
  
)

export default component.exports